import { Accordion, AccordionDetails, AccordionSummary, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import ExpandMoreIcon  from "@mui/icons-material/ExpandMore"
import { useSelector } from "react-redux"
import moment from "moment"
import { useTranslation } from "react-i18next"

const Course = () => {

  const personEducation = useSelector(state => state.salesforce.personEducation)
  const personEmployment = useSelector(state => state.salesforce.personEmployment)
  const { t } = useTranslation()

  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          // aria-controls="panel1a-content"
          aria-controls={`panel2a-content`}
          // id="panel1a-header"
          id={`panel2a-header`}
        >
          {t('academic.title')}
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="h5">{t('academic.dilomas')}</Typography>
          {personEducation.length === 0 && <p>{t('academic.no_diploma')}</p>}
          {personEducation.length > 0 && <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('PersonEducation.Name')}</TableCell>
                  <TableCell>{t('PersonEducation.Location__c')}</TableCell>
                  <TableCell>{t('PersonEducation.EndDate')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {personEducation.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.Name}</TableCell>
                    <TableCell>{row.Location__c}</TableCell>
                    <TableCell>{row.EndDate}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>}

          <Typography variant="h5" sx={{ mt: 2 }}>{t('academic.experience')}</Typography>
          {personEmployment.length === 0 && <p>{t('academic.no_experience')}</p>}
          {personEmployment.length > 0 && <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('PersonEmployment.Name')}</TableCell>
                  <TableCell>{t('PersonEmployment.EmployerCountry')}</TableCell>
                  <TableCell>{t('PersonEmployment.Position')}</TableCell>
                  <TableCell>{t('PersonEmployment.StartDate')}</TableCell>
                  <TableCell>{t('PersonEmployment.EndDate')}</TableCell>
                  <TableCell>{t('PersonEmployment.FullDescription__c')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {personEmployment.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.Name}</TableCell>
                    <TableCell>{row.EmployerCountry}</TableCell>
                    <TableCell>{row.Position}</TableCell>
                    <TableCell>{moment(row.StartDate).format('MM/YY')}</TableCell>
                    <TableCell>{moment(row.EndDate).format('MM/YY')}</TableCell>
                    <TableCell>{row.FullDescription__c}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>}
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default Course
